// @core/api/endpoints/activity/index.ts
// Auto-generated by corebuilder. DO NOT EDIT.
import { AcknowledgeActivities } from './acknowledge_activities';
import { AcknowledgeAll } from './acknowledge_all';
import { CreateMappingConfig } from './create_mapping_config';
import { DeleteMappingConfig } from './delete_mapping_config';
import { GetActivity } from './get_activity';
import { GetActivitySettings } from './get_activity_settings';
import { GetInboxCounts } from './get_inbox_counts';
import { ListActivities } from './list_activities';
import { ListDecisions } from './list_decisions';
import { ListInbox } from './list_inbox';
import { ListMappingConfigs } from './list_mapping_configs';
import { RecordDecision } from './record_decision';
import { UpdateActivitySettings } from './update_activity_settings';
import { UpdateMappingConfig } from './update_mapping_config';

// Re-export individual endpoints
export {
  AcknowledgeActivities,
  AcknowledgeAll,
  CreateMappingConfig,
  DeleteMappingConfig,
  GetActivity,
  GetActivitySettings,
  GetInboxCounts,
  ListActivities,
  ListDecisions,
  ListInbox,
  ListMappingConfigs,
  RecordDecision,
  UpdateActivitySettings,
  UpdateMappingConfig,
};

// Namespace export for convenient usage
export const activityApi = {
  AcknowledgeActivities,
  AcknowledgeAll,
  CreateMappingConfig,
  DeleteMappingConfig,
  GetActivity,
  GetActivitySettings,
  GetInboxCounts,
  ListActivities,
  ListDecisions,
  ListInbox,
  ListMappingConfigs,
  RecordDecision,
  UpdateActivitySettings,
  UpdateMappingConfig,
};
